{
  "TRANSFER_TO_AGENT": {
    "TOOLTIP": "Siirrä asiakaspalvelijalle",
    "MESSAGE": "Yhdistä minut asiakaspalvelijalle"
  },
  "COMPONENTS": {
    "FILE_BUBBLE": {
      "DOWNLOAD": "Lataa",
      "UPLOADING": "Lähetetään..."
    },
    "FORM_BUBBLE": {
      "SUBMIT": "Lähetä"
    },
    "MESSAGE_BUBBLE": {
      "RETRY": "Lähetä viesti uudelleen",
      "ERROR_MESSAGE": "Ei voitu lähettää, yritä uudestaan"
    },
    "MESSAGE_RATING": {
      "TOOLTIP": "Arvioi tämän vastauksen laatu"
    }
  },
  "WAITING_FOR_AGENT": {
    "MESSAGE": "Odota, että agentti liittyy"
  },
  "ROBOT_CHECK": {
    "TITLE": "Nopea turvatarkistus",
    "DESCRIPTION": "Ole hyvä ja suorita alla oleva tarkistus.",
    "VERIFYING": "Vahvistetaan…",
    "ERROR": "Se ei onnistunut. Yritä uudelleen.",
    "RETRY": "Yritä uudelleen"
  },
  "TEAM_AVAILABILITY": {
    "ONLINE": "Olemme online-tilassa",
    "OFFLINE": "Olemme tällä hetkellä poissa",
    "ONLINE_WITH_BOT": "Tiimi ja tekoälyavustajamme ovat online",
    "OFFLINE_WITH_BOT": "Tekoälyavustajamme on täällä auttamassa",
    "BOT_ONLY_REPLY": "Vastaa välittömästi"
  },
  "REPLY_TIME": {
    "IN_A_FEW_MINUTES": "Vastaa tyypillisesti muutamassa minuutissa",
    "IN_A_FEW_HOURS": "Tyypillisesti vastaa muutaman tunnin kuluessa",
    "IN_A_DAY": "Vastaa tyypillisesti päivässä",
    "BACK_IN": "Tulemme olemaan takaisin linjoilla"
  },
  "DAY_NAMES": {
    "SUNDAY": "Sunnuntai",
    "MONDAY": "Maanantai",
    "TUESDAY": "Tiistai",
    "WEDNESDAY": "Keskiviikko",
    "THURSDAY": "Torstai",
    "FRIDAY": "Perjantai",
    "SATURDAY": "Lauantai"
  },
  "START_CONVERSATION": "Aloita keskustelu",
  "END_CONVERSATION": "Lopeta keskustelu",
  "CONTINUE_CONVERSATION": "Jatka keskustelua",
  "YOU": "Sinä",
  "START_NEW_CONVERSATION": "Aloita uusi keskustelu",
  "RESOLVE_LATER": "Selvitämme tämän aiheen sähköpostitse/puhelimitse. Haluan nyt kysyä jostain muusta.",
  "VIEW_UNREAD_MESSAGES": "Sinulla on lukemattomia viestejä",
  "UNREAD_VIEW": {
    "VIEW_MESSAGES_BUTTON": "Näytä uudet viestit",
    "CLOSE_MESSAGES_BUTTON": "Sulje",
    "COMPANY_FROM": "lähettäjä",
    "BOT": "Botti"
  },
  "BUBBLE": {
    "LABEL": "Keskustele kanssamme"
  },
  "POWERED_BY": "Palvelun tarjoaa {brandName}",
  "EMAIL_PLACEHOLDER": "Ole hyvä ja syötä sähköpostiosoitteesi",
  "CHAT_PLACEHOLDER": "Kirjoita viestisi",
  "TODAY": "Tänään",
  "YESTERDAY": "Eilen",
  "PRE_CHAT_FORM": {
    "FIELDS": {
      "FULL_NAME": {
        "LABEL": "Koko nimi",
        "PLACEHOLDER": "Syötä koko nimesi",
        "REQUIRED_ERROR": "Koko nimi vaaditaan"
      },
      "EMAIL_ADDRESS": {
        "LABEL": "Sähköpostiosoite",
        "PLACEHOLDER": "Ole hyvä ja syötä email osoite",
        "REQUIRED_ERROR": "Sähköpostiosoite on pakollinen",
        "VALID_ERROR": "Ole hyvä ja syötä validi sähköposti"
      },
      "PHONE_NUMBER": {
        "LABEL": "Puhelinnumero",
        "PLACEHOLDER": "Ole hyvä ja syötä puhelinnumero",
        "REQUIRED_ERROR": "Puhelinnumero vaaditaan",
        "DIAL_CODE_VALID_ERROR": "Ole hyvä ja valitse maakoodi",
        "VALID_ERROR": "Anna kelvollinen puhelinnumero",
        "DROPDOWN_EMPTY": "Tuloksia ei löytynyt",
        "DROPDOWN_SEARCH": "Hae maata"
      },
      "MESSAGE": {
        "LABEL": "Viesti",
        "PLACEHOLDER": "Ole hyvä ja syötä viesti",
        "ERROR": "Viesti on liian lyhyt"
      }
    },
    "CAMPAIGN_HEADER": "Ole hyvä ja anna nimesi ja sähköpostisi ennen keskustelun aloittamista",
    "IS_REQUIRED": "on vaadittu",
    "REQUIRED": "Pakollinen",
    "REGEX_ERROR": "Anna kelvollinen arvo"
  },
  "FILE_SIZE_LIMIT": "Tiedosto ylittää sallitun {MAXIMUM_FILE_UPLOAD_SIZE} liitteen rajan",
  "CHAT_FORM": {
    "INVALID": {
      "FIELD": "Virheellinen kenttä"
    }
  },
  "EMOJI": {
    "PLACEHOLDER": "Etsi emojeista",
    "NOT_FOUND": "Yksikään emoji ei vastaa hakuasi",
    "ARIA_LABEL": "Emojivalitsin"
  },
  "CSAT": {
    "TITLE": "Anna arvio palvelusta",
    "SUBMITTED_TITLE": "Kiitos, että lähetit arvion",
    "PLACEHOLDER": "Kerro meille lisää..."
  },
  "EMAIL_TRANSCRIPT": {
    "BUTTON_TEXT": "Lähetä keskustelun tallenne",
    "SEND_EMAIL_SUCCESS": "Chat-keskustelu on lähetetty onnistuneesti",
    "SEND_EMAIL_ERROR": "Tapahtui virhe, yritä uudelleen"
  },
  "PORTAL": {
    "POPULAR_ARTICLES": "Suosittuja artikkeleita",
    "VIEW_ALL_ARTICLES": "Näytä kaikki artikkelit",
    "IFRAME_LOAD_ERROR": "Artikkelin lataamisessa tapahtui virhe. Ole hyvä ja päivitä sivu ja yritä uudelleen."
  },
  "CARDS": {
    "ACTIONS": {
      "OPEN": "Avaa",
      "BUY": "Osta"
    }
  },
  "ATTACHMENTS": {
    "image": {
      "CONTENT": "Kuvaviesti"
    },
    "audio": {
      "CONTENT": "Ääniviesti"
    },
    "video": {
      "CONTENT": "Videoviesti"
    },
    "file": {
      "CONTENT": "Liite"
    },
    "location": {
      "CONTENT": "Sijainti"
    },
    "fallback": {
      "CONTENT": "on jakanut URL-osoitteen"
    }
  },
  "FOOTER_REPLY_TO": {
    "REPLY_TO": "Vastaus viestiin:"
  }
}
